import React, { useState } from "react";
import axios from "axios";
import { Alert, Box, Button, CircularProgress, TextField } from "@mui/material";
import { Cartao, Pagina } from "./ui/Painel";

const CadastrarUsuarioEvento = () => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState(null);
  const [erros, setErros] = useState({});
  const [enviando, setEnviando] = useState(false);

  const validarCampos = () => {
    const novosErros = {};
    if (!nome.trim()) novosErros.nome = "Nome é obrigatório.";
    if (!email.trim()) novosErros.email = "E-mail é obrigatório.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) novosErros.email = "E-mail inválido.";
    if (!senha) novosErros.senha = "Senha é obrigatória.";
    else if (senha.length < 6) novosErros.senha = "A senha deve ter no mínimo 6 caracteres.";

    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem(null);
    if (!validarCampos()) return;

    setEnviando(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/usuarios/cadastrar`, { nome, email, senha });
      setMensagem({ text: "Usuário cadastrado com sucesso!", type: "success" });
      setNome("");
      setEmail("");
      setSenha("");
      setErros({});
    } catch (error) {
      console.error(error);
      setMensagem({ text: error.response?.data?.error || "Erro ao cadastrar usuário.", type: "error" });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Pagina
      eyebrow="Cadastros"
      titulo="Cadastrar usuário"
      descricao="Acesso para a equipe do evento: lista de convidados, leitor QR e inscrições."
      largura={720}
    >
      <Cartao titulo="Dados de acesso">
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {mensagem && <Alert severity={mensagem.type}>{mensagem.text}</Alert>}

          <TextField
            label="Nome"
            size="small"
            fullWidth
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            error={!!erros.nome}
            helperText={erros.nome}
          />
          <TextField
            label="E-mail"
            type="email"
            size="small"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!erros.email}
            helperText={erros.email}
          />
          <TextField
            label="Senha"
            type="password"
            size="small"
            fullWidth
            autoComplete="new-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            error={!!erros.senha}
            helperText={erros.senha || "Mínimo de 6 caracteres"}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" type="submit" disabled={enviando} sx={{ minWidth: 160 }}>
              {enviando ? <CircularProgress size={20} color="inherit" /> : "Cadastrar usuário"}
            </Button>
          </Box>
        </Box>
      </Cartao>
    </Pagina>
  );
};

export default CadastrarUsuarioEvento;
